import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientCognitiveJourney = (state, patientId) =>
  allModelsSelector(state, 'PatientCognitiveJourney', (pcj) => pcj.patientId === patientId).sort(
    (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt),
  )[0];
